/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CnSupportHK.css";
import { Link } from "react-router-dom";

class CnSupportHK extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  render() {
    return (
      <div className="CnSupportHK-view">
        <div className="CnSupportHK-section">
          <Link to="/Cn">
            <div className="CnSupportHK-back">
              <div className="CnSupportHK-backBtn"></div>
              <div className="CnSupportHK-backText">返回</div>
            </div>
          </Link>
          <div className="CnSupportHK-logo" />
          <div className="CnSupportHK-title">
            与香港同行
            <br />
            齐心抗疫
          </div>

          <div className="CnSupportHK-outerContainer">
            <div className="CnSupportHK-container">
              <a
                href="https://peacemaker.check.plus/MissionDetails?no=55"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="CnSupportHK-description">紧急支援基层基金</div>
                <div className="CnSupportHK-QR1" />
              </a>
            </div>

            <div className="CnSupportHK-container2">
              <a
                href="https://sunrisechurch.check.plus/MissionDetails?no=90"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="CnSupportHK-description">防疫基金</div>
                <div className="CnSupportHK-QR2" />
              </a>
            </div>

            <div className="CnSupportHK-container">
              <a
                href="https://lovefoundation.check.plus/MissionDetails?no=89"
                target="_blank"
                rel="noopener noreferrer"
              >
                <div className="CnSupportHK-description">以爱同行 抗疫捐赠</div>
                <div className="CnSupportHK-QR3" />
              </a>
            </div>
          </div>
        </div>

        <div className="CnSupportHK-footer">
          <div className="CnSupportHK-footerNav">
            <Link to="/CnTeam">
              <div className="CnSupportHK-footerNavItem">创办人的故事</div>
            </Link>
            <Link to="/CnFaq">
              <div className="CnSupportHK-footerNavItem">常见问题</div>
            </Link>
            <Link to="/CnContact">
              <div className="CnSupportHK-footerNavItem">联络我们</div>
            </Link>
          </div>

          <div className="CnSupportHK-footer_text">
            香港九龙油塘四山街 11 号
            <br />
            华利工业大厦5楼A室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切权利。
          </div>
        </div>
      </div>
    );
  }
}

export default CnSupportHK;
